export default {
    sort: [
        {
            backers: { 
                order: 'desc', 
                mode: 'max' 
            } 
        },
    ],
    query: {
        bool: {
            must_not: {
                exists: {
                    field: 'hidden'
                }
            }
        },
    },
    
}